import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";

function SearchBox() {

    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin
    const [loading, setLoading] = useState(false);
    const [clients, setClients] = useState([]);
    const [searchItem, setSearchItem] = useState('');

    useEffect(()=>{
        const loadClients = async ()=> {
            setLoading(true);
            const response = await axios.get('https://homesafetysolutions.pythonanywhere.com/api/clients/', {
            // const response = await axios.get('http://127.0.0.1:8000/api/clients/', {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }
            });
            setClients(response.data);
            setLoading(false)
        }

        loadClients();
    }, []);

    return (
        <div style={{textAlign: 'center'}}>
            <h3>Search Filter By Address: </h3>
            <br />
            <input
                type={'text'}
                placeholder={'Search...'}
                onChange={(e)=> setSearchItem(e.target.value)}
                style={{width:'30%', height: '25px'}}
            />
            <br/>
            <br/>

            {loading ? (<h4>Loading...</h4>) : (
                (clients.filter((value) => {
                    if (searchItem === ''){
                        return value
                    } else if (value.work_site_address.toLowerCase().includes(searchItem.toLowerCase())){
                        return value
                    }else if (value.project_ID.toLowerCase().includes(searchItem.toLowerCase())){
                        return value
                    }
                }).map(item => <div
                    key={item.id}>
                    <Link

                        className={'btn btn-outline-primary'}
                        style={{marginBottom: "10px"}}
                        to={`/search_results/${item.id}`}
                    >
                        {item.work_site_address} | {item.project_ID}
                    </Link><br/></div> ))
            )}
        </div>
    );
}

export default SearchBox;

